<template>
  <div class="ex-item">
    <div class="pic">
      <router-link :to="`/exhibition/${data.id}`" target="_blank"><img :data-src="data.imageUrl | imageUrl" :class="data.imageUrl | imageClass(data.imageWidth, data.imageHeight, 0.73)" :src="data.imageUrl | imageUrl('?imageView2/1/w/376/h/516')" /></router-link>
    </div>
    <div class="content">
      <h2 class="title">
        <router-link :to="`/exhibition/${data.id}`" :title="data.name" target="_blank">{{data.name}}</router-link>
      </h2>
      <p class="name" :title="data.pavilion">{{data.pavilion}}</p>
      <p class="time">{{data.exStartTime | formatDateRange(data.exEndTime)}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ExhibitionItem',
  props: { data: Object }
}
</script>
<style scoped>
.ex-item {
  float: left;
  width: 188px;
  height: 368px;
  margin: 0 21px 30px 0;
}
.ex-item .pic {
  position: relative;
  width: 100%;
  height: 258px;
  border-radius: 4px;
  overflow: hidden;
  background-color: #e9ebf2;
}

.ex-item .content {
  margin-top: 10px;
}
.ex-item .content .title {
  font-size: 16px;
  font-weight: normal;
  line-height: 20px;
  color: #333;
  max-height: 40px;
  overflow: hidden;
}
.ex-item .content .name {
  margin-top: 10px;
  font-size: 14px;
  line-height: 17px;
  color: #666;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ex-item .content .time {
  margin-top: 6px;
  font-size: 12px;
  line-height: 15px;
  color: #666;
}
.ex-item:hover .title {
  color: #1e88f5;
}
</style>
